import CustomInput from "../CustomInput";
import CustomButton from "../CustomButton";
import { ReactComponent as Close } from 'assets/header/close.svg'
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { IInfo, ITempInfo } from "types/quote";
import { ITerms } from "types/signup";
import { termsContent } from "data/terms";
import TermsModal from "./TermsModal";
import { countryCodeToEmoji, getKoreaDateTime } from "components/function";
import axios from "axios";
import { ReactComponent as ArrowRight } from 'assets/signup/arrowRight.svg'
import { ReactComponent as CheckOn } from 'assets/common/checkOn.svg'
import { ReactComponent as CheckOff } from 'assets/common/checkOff.svg'
import { ReactComponent as Check } from 'assets/common/check.svg'
import { jsonAxios } from "components/axios";

interface IMainQuoteModal {
    userPop: boolean,
    setUserPop: React.Dispatch<React.SetStateAction<boolean>>,
    setTempRefresh: React.Dispatch<React.SetStateAction<boolean>>,
    info: IInfo
    setInfo: React.Dispatch<React.SetStateAction<IInfo>>,
}

const MainQuoteModal = ({
    userPop,
    setUserPop,
    setTempRefresh,
    info,
    setInfo,
}: IMainQuoteModal) => {
    const [all, setAll] = useState<boolean>(false);
    const [require, setRequire] = useState<boolean>(false);
    const [tempInfo, setTempInfo] = useState<ITempInfo>({} as ITempInfo)
    const [tempClear, setTempClear] = useState<boolean>(false)
    const [terms, setTerms] = useState<ITerms[]>([
        {
            id: 0,
            title: 'PulseOnShip 이용약관 동의',
            content: termsContent[0],
            chk: false,
            required: true,
        },
        {
            id: 1,
            title: '개인정보 수집 및 이용 동의',
            content: termsContent[1],
            chk: false,
            required: true,
        },
        {
            id: 2,
            title: '마케팅 정보 수신 동의',
            content: termsContent[1],
            chk: false,
            required: false,
        },
    ]);
    const [popTermsOpen, setPopTermsOpen] = useState<boolean>(false);
    const [selectTerms, setSelectTerms] = useState<ITerms>({} as ITerms)

    useEffect(() => {
        setTempClear(
            !!tempInfo.name &&
            !!tempInfo.email &&
            !!tempInfo.phone &&
            !!tempInfo.companyName &&
            require
        )
    }, [tempInfo, require])

    useEffect(() => {
        const termsAgree = terms.every(arr => arr.chk);
        const requireAgree = terms
            .filter(term => term.required)
            .every(term => term.chk);
        setAll(termsAgree);
        setRequire(requireAgree);
    }, [all, terms, require])

    // 전체 약관 체크
    const allChk = () => {
        setAll(p => {
            if (p) {
                setRequire(false);
            }
            return !p
        });
        setTerms(p => {
            const temp = [...p]
            temp.map(arr => arr.chk = !all)
            return temp
        })
    }

    // 필수 약관 체크
    const requireChk = () => {
        setRequire(!require);
        setTerms(t => {
            const temp = [...t]
            temp.map(arr => arr.required ? arr.chk = !require : arr.chk)
            return temp
        })
    }

    const saveQuoteTemp = async () => {
        const reqData = {
            isSigned: false,
            originId: info.originId,
            destinationId: info.destinationId,
            shipmentMode: info.shipmentMode,
            transportType: info.transportType,
            tradeType: "string",
            containerAmount: info.amount,
            containerUnit: info.containerType,
            username: tempInfo.name,
            email: tempInfo.email,
            phone: tempInfo.phone,
            companyName: tempInfo.companyName
        }

        jsonAxios.post('quote/real', reqData).then(res => {
            console.log(res.data)
            if (res.data.code === 200) {
                const url = 'https://teamroom.nate.com/api/webhook/44e6aee7/I1v1mS2IdjZ8qQHohkm16F9M';

                const params = new URLSearchParams();
                params.append('content', `📦 Pulse On Ship 메인 비로그인 견적 요청 ${info.transportType === 'AIR' ? '✈️' : '⚓️'}\n
신청일시: ${getKoreaDateTime()}
이름: ${tempInfo.name}
회사이름: ${tempInfo.companyName}
연락처: ${tempInfo.email}
이메일: ${tempInfo.phone}
운송: ${info.transportType}
경로: ${countryCodeToEmoji(info.originCode.slice(0, 2))} ${info.originCode} | ${info.originAddress} > ${countryCodeToEmoji(info.destinationCode.slice(0, 2))} ${info.destinationCode} | ${info.destinationAddress}
${info.transportType === 'SEA' ? `종류 : ${info.shipmentMode}` : ''}
마케팅 정보 수신 동의 : ${terms[2].chk ? '동의' : '미동의'}`);

                axios.post(url, params, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                    .then(response => {
                        console.log('전송 성공:', response.data);
                    })
                    .catch(error => {
                        console.error('전송 실패:', error);
                    }).finally(() => {
                        setTempRefresh(true)
                        toast.success('정상적으로 요청되었습니다. 영업일 기준 1~2일후 연락드리겠습니다.')
                        setInfo({
                            transportType: 'SEA',
                            shipmentMode: 'FCL',
                        } as IInfo)
                        setTempInfo({} as ITempInfo)
                        setUserPop(false)
                        setTerms(p => {
                            const temp = [...p]
                            temp.map(arr => arr.chk = false)
                            return temp
                        })
                        setTimeout(() => {
                            setTempRefresh(false)
                        }, 300)
                    })
            }
            // else {
            //     toast.error('저장중 오류가 발생했습니다.')
            //     setOnce(false)
            // }
        })
    };

    const openTermPop = (item: ITerms) => {
        setSelectTerms(item)
        setPopTermsOpen(true)
    }

    if (!userPop) return null;

    return (
        <div className="z-50 absolute inset-0 flex flex-col items-center gap-10 bg-white p-10 rounded-lg w-full h-full">
            <Close
                className='top-4 right-4 absolute w-6 cursor-pointer'
                onClick={() => setUserPop(false)}
            />
            <div className='flex flex-col flex-1 gap-4 w-full overflow-auto'>
                <p className='font-semibold text-xl'>개인정보를 입력해주시면, <br />영업일 기준 1~2일 이내에 답변 드리겠습니다.</p>
                <CustomInput
                    type='text'
                    className='w-full shrink-0'
                    placeholder='이름'
                    value={tempInfo.name ?? ''}
                    onChange={(e) => {
                        setTempInfo(p => ({
                            ...p,
                            name: e.target.value
                        }))
                    }}
                />
                <CustomInput
                    type='email'
                    className='w-full shrink-0'
                    placeholder='이메일'
                    value={tempInfo.email ?? ''}
                    onChange={(e) => {
                        setTempInfo(p => ({
                            ...p,
                            email: e.target.value
                        }))
                    }}
                />
                <CustomInput
                    type='text'
                    className='w-full shrink-0'
                    placeholder='연락처'
                    value={tempInfo.phone ?? ''}
                    onChange={(e) => {
                        setTempInfo(p => ({
                            ...p,
                            phone: e.target.value
                        }))
                    }}
                />
                <CustomInput
                    type='text'
                    className='w-full shrink-0'
                    placeholder='회사명'
                    value={tempInfo.companyName ?? ''}
                    onChange={(e) => {
                        setTempInfo(p => ({
                            ...p,
                            companyName: e.target.value
                        }))
                    }}
                />
                <div className='flex flex-col gap-3 mb-4.5 mobile:mb-2'>
                    <p className='text-red'>필수항목에 모두 동의하지 않으시면 본 서비스를 이용하실 수 없습니다.</p>
                    <div
                        className='bg-[#F8F8FA] px-6 mobile:px-4 rounded-lg h-15 mobile:h-10 mobile:text-sm text-xl'
                    >
                        <label
                            htmlFor='allCheck'
                            className='flex justify-between items-center h-full cursor-pointer'>
                            이용약관 전체동의

                            {
                                all ?
                                    <CheckOn className='mobile:w-6 mobile:h-6' /> :
                                    <CheckOff className='mobile:w-6 mobile:h-6' />
                            }
                            <input
                                className="hidden accent-primary"
                                type="checkbox"
                                name=""
                                id="allCheck"
                                checked={all}
                                onChange={allChk}
                            />
                        </label>
                    </div>
                </div>

                <div className='mb-3 mobile:mb-2 px-6 mobile:px-4 rounded-lg h-15 mobile:h-10 mobile:text-sm text-xl'>
                    <label
                        htmlFor='requireCheck'
                        className='flex justify-between items-center h-full cursor-pointer'>
                        필수약관 전체동의

                        {
                            require ?
                                <CheckOn className='mobile:w-6 mobile:h-6' /> :
                                <CheckOff className='mobile:w-6 mobile:h-6' />
                        }
                        <input
                            className="hidden accent-primary"
                            type="checkbox"
                            name=""
                            id="requireCheck"
                            checked={require}
                            onChange={requireChk}
                        />
                    </label>
                </div>
                <div className='flex flex-col gap-3 mb-8 mobile:mb-6 px-6 mobile:px-4 text-[#A4A4A4] mobile:text-sm text-lg'>
                    {
                        terms.map((item: ITerms, idx: number) => (
                            <div
                                className='flex justify-between items-center'
                                key={idx}>
                                <div
                                    className={`flex gap-1 cursor-pointer hover:text-primary hover:underline transition-all duration-300 ${item.chk && 'text-black'}`}
                                    onClick={() => openTermPop(item)}
                                >
                                    {
                                        item.required ? <p className='text-primary'>[필수] </p> : <p>[선택] </p>
                                    }
                                    {item.title}
                                </div>
                                <div className='h-8'>
                                    {
                                        item.chk ?
                                            <Check
                                                className='mobile:w-6 cursor-pointer'
                                                onClick={() => {
                                                    setTerms(t => {
                                                        const temp = [...t]
                                                        temp[idx].chk = !temp[idx].chk
                                                        return temp
                                                    })
                                                }}
                                            /> :
                                            <p >
                                                <ArrowRight
                                                    className='mobile:w-6 cursor-pointer'
                                                    onClick={() => {
                                                        setTerms(t => {
                                                            const temp = [...t]
                                                            temp[idx].chk = !temp[idx].chk
                                                            return temp
                                                        })
                                                    }}
                                                />
                                            </p>
                                    }
                                </div>
                            </div>
                        ))
                    }
                    <p>화살표를 눌러 내용을 읽어주세요. 체크박스를 선택하면, 다음 항목을 모두 읽고 동의한 것으로 간주합니다.</p>
                </div>
                {/* 약관 팝업 */}
                <TermsModal
                    isOpen={popTermsOpen}
                    setIsOpen={setPopTermsOpen}
                    title={selectTerms.title}
                    content={selectTerms.content}
                />
            </div>
            <CustomButton
                title={'견적받기'}
                disabled={!tempClear}
                onClick={saveQuoteTemp}
                className={'!min-w-0 w-full !text-base bg-primary'}
            />
        </div>
    );
}

export default MainQuoteModal;